module.exports = __webpack_public_path__ + "img/max-file-add--pdf.9f442ed0.svg";